import { DisclosureStatementText } from '#/components/content/DisclosureStatement';
import { cn } from '#/utils/cn';

export function PageDisclaimer({ className }: { className?: string }) {
  return (
    <section
      className={cn(className, 'border-blue-30 mt-32 border-t pt-32 lg:mt-64')}
    >
      <DisclosureStatementText className="text-static-12 text-fg-muted" />
    </section>
  );
}
